import api from 'config/api.config';
import { getErrorMessage } from 'utils/errors';

/**
 * Fetch comments settings for a specific social media account.
 * @param social_media_account_id - The ID of the social media account.
 * @returns - The comments settings data.
 */
export const getFollowingsSettings = async (social_media_account_id: string): Promise<any> => {
  try {
    const response = await api.post(
      '/api/actions/followings/followings-settings',
      { social_media_account_id }
    );

    return response.data;
  } catch (error: unknown) {
    throw new Error(getErrorMessage(error, 'Failed to fetch comments settings'));
  }
};

export const manageCommentsSettings = async (
  social_media_account_id: string,
  action_id: string,
  settings_type: string,
  operation: string,
  settings_value: unknown
): Promise<any> => {
  try {
    const response = await api.post(
      '/api/actions/followings/followings-settings-update',
      {
        social_media_account_id,
        action_id,
        settings_type,
        operation,
        settings_value
      }
    );

    return response.data;
  } catch (error: unknown) {
    throw new Error(getErrorMessage(error, 'Failed to fetch comments settings'));
  }
};

export const getFollowingsSettingsLogs = async (
  account_id: string,
  page?: number,
  limit?: number,
  date?: string
): Promise<any> => {
  try {
    const body: Record<string, unknown> = { account_id };
    if (page !== undefined) body.page = page;
    if (limit !== undefined) body.limit = limit;
    if (date) body.date = date;

    const response = await api.post(
      '/api/actions/followings/followings-settings-logs',
      body
    );

    return response.data;
  } catch (error: unknown) {
    throw new Error(getErrorMessage(error, 'Failed to fetch likes settings logs'));
  }
};

export const updateFollowerRatio = async (account_id: string, follower_ratio: unknown): Promise<any> => {
  try {
    const response = await api.post(
      '/api/actions/followings/update-follower-ratio',
      { account_id, follower_ratio }
    );

    return response.data;
  } catch (error: unknown) {
    throw new Error(getErrorMessage(error, 'Failed to fetch likes settings logs'));
  }
};
